<template>
  <DetailDialog
    title="子の情報"
    icon="mdi-baby-face-outline"
    :show-save="false"
    cancel-label="閉じる"
    :cancel-min-width="128"
    body-padding="24px"
    @cancel="$emit('cancel')"
  >
    <div class="children-info-grid">
      <div class="field-block">
        <span class="field-label">ID</span>
        <div class="field-value">
          {{ child.id }}
        </div>
      </div>
      <div class="field-block">
        <span class="field-label">セイメイ</span>
        <div class="field-value">
          {{ formatChildName(child) }}
        </div>
      </div>
      <div class="field-block">
        <span class="field-label">性別</span>
        <div class="field-value">
          {{ child.gender }}
        </div>
      </div>
      <div class="field-block">
        <span class="field-label">生年月日</span>
        <div class="field-value">
          {{ child.birthday }}
        </div>
      </div>
      <div class="field-block note-block">
        <div class="note-header">
          <span class="field-label">特記</span>
          <EditHistoryPopover
            :history="noteHistory"
            empty-text="データがありません"
          />
        </div>
        <div class="field-value note-value">
          {{ child.note }}
        </div>
      </div>
    </div>
  </DetailDialog>
</template>

<script>
import DetailDialog from "@/vue/shared/ui/DetailDialog.vue";
import EditHistoryPopover from "@/vue/shared/ui/EditHistoryPopover.vue";
import { formatChildName } from "./childName";

export default {
  name: "ChildrenInfoDetailWindow",
  components: {
    DetailDialog,
    EditHistoryPopover
  },
  props: {
    child: {
      type: Object,
      required: true
    },
    noteHistory: {
      type: Array,
      default: () => []
    }
  },
  emits: ["cancel"],
  methods: {
    formatChildName
  }
};
</script>

<style lang="scss" scoped>
.children-info-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);
}

.note-block {
  grid-column: 1 / -1;
}

.note-header {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.note-value {
  background-color: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 3px;
  padding: 8px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

@media (max-width: 820px) {
  .children-info-grid {
    gap: 16px;
    grid-template-columns: 1fr;
  }

  .note-block {
    grid-column: 1 / -1;
  }
}
</style>
